
import SingleBlog from "./single_blog"
import {  useNavigate, useParams } from "react-router-dom"


const SingleMainBlog = () => {
    const id  = useParams()
    const navigate = useNavigate()
    const redirect = () =>{
        navigate("/blog_edit")
    }
    return (
        <>
            <SingleBlog blogId ={id} redirect={redirect}/>
        </>
    )
}


export default SingleMainBlog